

  import Vue from 'vue'
  import Component from "vue-class-component";
  import {Prop} from "vue-property-decorator";
  import {RawLocation} from "vue-router";

  @Component({
    components: {}
  })
  export default class LinkChip extends Vue {

    @Prop()
    protected to!: string|RawLocation;
    @Prop()
    protected value!: string;
    @Prop({default: ""})
    protected icon!: string;
    @Prop({default: ""})
    protected color!: string;
    @Prop({default: true})
    protected whiteText!: boolean;
    @Prop({default: false})
    protected dark!: boolean;

    protected get cssClass(): string[] {
      return [this.to ? 'lighten-2' : 'darken-2', this.getColor, this.getTextColor];
    }

    protected get getColor(): string {
      return this.color || 'primary';
    }

    protected get getTextColor(): string {
      return !this.whiteText ? 'white--text' : '';
    }

  }

